
import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  name: "layout-ios-dummy",
  props: {
    extraHeight: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters("ui", ["isPC"]),
  },
});
